import { FormSchemaDto } from "@amzn/crowd-front-end-common-library";
import { FieldSchemaBase } from "@amzn/crowd-front-end-common-library/dist/src/forms/shared";

const name = (showPlaceholder: boolean): FieldSchemaBase => ({
  propertyName: "name",
  label: "Team name",
  propertyType: "string",
  placeholder: showPlaceholder ? "e.g. AWS Biz Dev" : "",
  hintText: "Maximum 350 characters",
  hidden: false,
  validationRules: {
    presence: {
      allowEmpty: false,
      message: "^Team name is required.",
    },
    length: {
      maximum: 350,
      message:
        "^The team name has too many characters. Type a team name from 1 to 350 characters.",
    },
  },
});
const owner = (showPlaceholder: boolean): FieldSchemaBase => ({
  propertyName: "owner",
  label: "Team owner",
  propertyType: "employee",
  placeholder: showPlaceholder ? "Search..." : "",
  hidden: false,
  validationRules: {
    presence: false,
  },
});
const description: FieldSchemaBase = {
  propertyName: "description",
  label: "Team description",
  propertyType: "text",
  hintText: "Maximum 250 characters",
  hidden: false,
  validationRules: {
    length: {
      maximum: 250,
      message:
        "^The team description has too many characters. Type a team description from 1 to 250 characters.",
    },
    presence: false,
  },
};
const charter: FieldSchemaBase = {
  propertyName: "charter",
  label: "Team charter",
  propertyType: "text",
  hintText: "Maximum 2000 characters",
  hidden: false,
  validationRules: {
    length: {
      maximum: 2000,
      message:
        "^The team charter has too many characters. Type a team charter from 1 to 2000 characters.",
    },
    presence: false,
  },
};
const tenets: FieldSchemaBase = {
  propertyName: "tenets",
  label: "Team tenets",
  propertyType: "text",
  hintText: "Maximum 5000 characters",
  hidden: false,
  validationRules: {
    length: {
      maximum: 5000,
      message:
        "^The team tenets have too many characters. Type team tenets from 1 to 5000 characters.",
    },
    presence: false,
  },
};

const admins: FieldSchemaBase = {
  propertyName: "admins",
  label: "Team admin(s)",
  propertyType: "multiselect<employee>",
  hidden: false,
  validationRules: {
    presence: false,
  },
};

const teamFormSchema: FormSchemaDto = {
  groups: [
    {
      groupLabel: "Team details",
      groupId: "general-group",
      fieldDefinitions: [
        name(true),
        owner(true),
        description,
        charter,
        tenets,
        admins,
      ],
    },
    {
      groupLabel: "Team edit information",
      groupId: "edit-team-group",
      fieldDefinitions: [
        name(false),
        owner(false),
        description,
        charter,
        tenets,
      ],
    },
  ],
};

export default teamFormSchema;
